export class Survey{
    question: string;
    value: string;
}